import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "./../../examples/Navbars/DashboardNavbar/index";
import MDBox from "./../../components/MDBox/index";
import { Grid, Card, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import MDTypography from "./../../components/MDTypography/index";
import Footer from "./../../examples/Footer";
import MDInput from "components/MDInput";
import {
  getInsurance,
  getRequestGroup,
  getReservedDays,
  getReservedTimesNoDayId,
  getSubRequestGroup,
  getReservedSubTimes,
  addReservedSubTimes,
  addPatientInformation,
  sendPaymentLink,
} from "../../api/routes";
import MDButton from "./../../components/MDButton/index";
import { buildReservationSlots, findInitialReservationSlot, findReservationSlot, isReservedSlot } from "../../components/reservationSlots";
import Loading from "../../components/Loading";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";


export default function NewReservation() {
  const { state } = useLocation();
  const [mainInsurance, setMainInsurance] = useState([]);
  const [subRequestGroupData, setSubRequestGroupData] = useState([]);
  const [requestGroupData, setRequestGroupData] = useState([]);
  const [reservedDays, setReservedDays] = useState([]);
  const [clickedReservationDate, setClickedReservationDate] = useState("");
  const [clickedReservationTime, setClickedReservationTime] = useState("");
  const [requestedInitialTime, setRequestedInitialTime] = useState(state?.time || "");
  const [service, setService] = useState("");
  const [openSubService, setOpenSubService] = useState(false);
  const [openReservationDate, setOpenReservationDate] = useState(false);
  const [openReservationTime, setOpenReservationTime] = useState(false);
  const [subService, setSubService] = useState("");
  const [reservedTimes, setReservedTimes] = useState([]);
  const [insurance, setInsurance] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reservedSubTimes, setReservedSubTimes] = useState([]);
  const [information, setInformation] = useState({
    name: "",
    lastName: "",
    nationalCode: "",
    phoneNumber: "",
    mainInsuranceId: "",
    insuranceId: "",
    insuranceRefCode: "",
  });

  useEffect(() => {
    if (state) {
      setClickedReservationDate(state?.reservationDate);
      setRequestedInitialTime(state?.time || "");
    }
  }, [state]);

  useEffect(() => {
    setLoading(true);
    getInsurance(1, (isOk, data) => {
      if (!isOk) return toast.error(data.message);
      else return setInsurance(data);
    });
    getInsurance(0, (isOk, data) => {
      if (!isOk) return toast.error(data.message);
      else return setMainInsurance(data);
    });
    getRequestGroup((isOk, data) => {
      setLoading(false);
      if (!isOk) return toast.error(data.message);
      else {
        setRequestGroupData(data);
        if (state)
          setService(data.find(item => item.requestGroupId === state?.requestGroupId));
      }
    });
  }, []);

  useEffect(() => {
    if (service?.requestGroupId) {
      setLoading(true);
      getSubRequestGroup(service?.requestGroupId, (isOk, data) => {
        setLoading(false);
        if (!isOk) return toast.error(data.message);
        else {
          setOpenSubService(true);
          setSubRequestGroupData(data);
          if (state)
            setSubService(data.find(item => item.subRequestGroupId === state?.subRequestGroupId));
        }
      });
    }
  }, [service]);
  const clearSchedule = () => {
    setClickedReservationDate("");
    setClickedReservationTime("");
    setReservedDays([]);
    setReservedTimes([]);
    setReservedSubTimes([]);
    setOpenReservationDate(false);
    setOpenReservationTime(false);
    setRequestedInitialTime("");
  };
  const handleChange = (event) => {
    clearSchedule();
    setSubService("");
    setSubRequestGroupData([]);
    setService(event.target.value);
  };
  const handleChange1 = (event) => {
    clearSchedule();
    setSubService(event.target.value);
  };
  useEffect(() => {
    if (service?.requestGroupId && subService?.subRequestGroupId) {
      setLoading(true);
      getReservedDays(service?.requestGroupId ?? service, subService?.subRequestGroupId ?? subService, (isOk, data) => {
        setLoading(false);
        if (!isOk) return toast.error(data.message);
        else {
          setReservedDays(data);
          return setOpenReservationDate(true);
        }
      });
    }
  }, [service, subService]);
  const handleReservationDateChange = (event) => {
    setClickedReservationTime("");
    setReservedTimes([]);
    setReservedSubTimes([]);
    setOpenReservationTime(false);
    setRequestedInitialTime("");
    setClickedReservationDate(event.target.value);
  };
  const handleReservationTimeChange = (event) => {
    setClickedReservationTime(event.target.value);
  };
  useEffect(() => {
    let cancelled = false;
    if (service?.requestGroupId && subService?.subRequestGroupId && clickedReservationDate) {
      setLoading(true);
      getReservedTimesNoDayId(service.requestGroupId, subService.subRequestGroupId, clickedReservationDate, (isOk, data) => {
        if (cancelled) return;
        if (!isOk) {
          setLoading(false);
          return toast.error(data?.message);
        }
        const spans = Array.isArray(data) ? data : [];
        setReservedTimes(spans);
        if (!spans.length) {
          setLoading(false);
          setReservedSubTimes([]);
          setOpenReservationTime(false);
          return;
        }
        getReservedSubTimes(service.requestGroupId, clickedReservationDate, subService.subRequestGroupId, (success, booked) => {
          if (cancelled) return;
          setLoading(false);
          if (!success) return toast.error(booked?.message);
          setReservedSubTimes(Array.isArray(booked) ? booked : []);
          setOpenReservationTime(true);
        }, true);
      });
    }
    return () => { cancelled = true; };
  }, [service, subService, clickedReservationDate]);

  const subTimesList = buildReservationSlots(reservedTimes);
  const selectedSlot = findReservationSlot(subTimesList, clickedReservationTime);

  useEffect(() => {
    if (!requestedInitialTime || !subTimesList.length) return;
    const initialSlot = findInitialReservationSlot(subTimesList, requestedInitialTime, state?.reservationDayId);
    if (initialSlot) setClickedReservationTime(initialSlot.key);
    setRequestedInitialTime("");
  }, [reservedTimes, requestedInitialTime, state?.reservationDayId]);

  const submit = () => {
    const insuranceRefCode = information.insuranceRefCode.trim();
    if (!selectedSlot || !service?.requestGroupId || !subService?.subRequestGroupId || isReservedSlot(selectedSlot, reservedSubTimes)) {
      return toast.error("لطفاً خدمت، تاریخ و ساعت نوبت را انتخاب کنید.");
    }
    const data = {
      reservationDayId: selectedSlot.reservationDayId,
      requestGroupId: service.requestGroupId,
      subRequestGroupId: subService.subRequestGroupId,
      subTime: selectedSlot.time,
      reservationDate: clickedReservationDate,
      endReservationTime: selectedSlot.endReservationTime
    };
    setLoading(true);
    addReservedSubTimes(data, (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else if (data.length > 0) {
        const patientData = {
          firstName: information.name,
          lastName: information.lastName,
          nationalCode: information.nationalCode,
          mobileNumber: information.phoneNumber,
          mainInsuranceId: information.mainInsuranceId,
          insuranceId: information.insuranceId,
          insuranceRefCode: insuranceRefCode || null,
          reservationDate: data[0].reservationDate,
          reservationTime: data[0].subTime,
          groupName: `${service.nameGroup} ${subService.subNameGroup}`,
          subRequestGroupId: subService.subRequestGroupId,
          reservedSubTimesId: data[0].reservedSubTimesId,
          requestGroupId: service.requestGroupId,
        };
        addPatientInformation(patientData, (isOk, data) => {
          if (!isOk) {
            setLoading(false);
            return toast.error(data.message);
          } else {
            const savedPatient = data[0];
            const sendLink = () => {
              const paymentData = {
                patientId: savedPatient.patientId,
                phoneNumber: savedPatient.mobileNumber,
              };
              sendPaymentLink(paymentData, (paymentOk, paymentResponse) => {
                setLoading(false);
                if (!paymentOk) return toast.error(paymentResponse?.message || "نوبت ثبت شد اما ارسال لینک پرداخت ناموفق بود.");
                toast.success("نوبت ثبت شد و لینک پرداخت ارسال شد");
                setClickedReservationDate("");
                setClickedReservationTime("");
                setService("");
                setSubService("");
                setInformation({
                  name: "", lastName: "", nationalCode: "", phoneNumber: "",
                  mainInsuranceId: "", insuranceId: "", insuranceRefCode: "",
                });
              });
            };
            sendLink();
          }
        });
      }
    });
  };

  return (
    <>
      <DashboardLayout>
        <Loading loading={loading} />
        <MDBox pt={2} mb={6}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                  <MDTypography variant="h6" color="white">
                    ثبت نوبت جدید
                  </MDTypography>
                  <DashboardNavbar />
                </MDBox>
                <MDBox px={{ xs: 2, md: 4 }} pt={5} pb={3} >
                  <MDBox mb={2} sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <MDBox sx={{ borderRadius: "10px", bgcolor: "#e7f0ff", color: "#1976d2", width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 14 }}>۱</MDBox>
                    <MDTypography variant="h6" fontWeight="medium">اطلاعات بیمار</MDTypography>
                  </MDBox>
                  <Grid container spacing={2.5} mb={4}>
                    <Grid item xs={12} sm={6} lg={3}>
                      <MDInput fullWidth required label="نام" value={information.name} onChange={(event) => setInformation((prev) => ({ ...prev, name: event.target.value }))} />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <MDInput fullWidth required label="نام خانوادگی" value={information.lastName} onChange={(event) => setInformation((prev) => ({ ...prev, lastName: event.target.value }))} />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <MDInput fullWidth required type="text" inputProps={{ inputMode: "numeric" }} label="کد ملی" value={information.nationalCode} onChange={(event) => setInformation((prev) => ({ ...prev, nationalCode: event.target.value }))} />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <MDInput fullWidth required type="tel" label="شماره موبایل" value={information.phoneNumber} onChange={(event) => setInformation((prev) => ({ ...prev, phoneNumber: event.target.value }))} />
                    </Grid>
                  </Grid>

                  <MDBox mb={2} sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <MDBox sx={{ borderRadius: "10px", bgcolor: "#e7f0ff", color: "#1976d2", width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 14 }}>۲</MDBox>
                    <MDTypography variant="h6" fontWeight="medium">اطلاعات بیمه</MDTypography>
                  </MDBox>
                  <Grid container spacing={2.5} mb={4}>
                    <Grid item xs={12} sm={6} lg={4}>
                      <FormControl required fullWidth>
                        <InputLabel>نوع بیمه درمانی</InputLabel>
                        <Select label="نوع بیمه درمانی" sx={{ height: "44.3px" }} value={information.mainInsuranceId}
                          onChange={(event) => setInformation((prev) => ({ ...prev, mainInsuranceId: event.target.value }))}>
                          {mainInsurance.map((item) => <MenuItem key={item.idInsurance} value={item.idInsurance}>{item.InsuranceName}</MenuItem>)}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <FormControl fullWidth>
                        <InputLabel>بیمه تکمیلی (اختیاری)</InputLabel>
                        <Select label="بیمه تکمیلی (اختیاری)" sx={{ height: "44.3px" }} value={information.insuranceId}
                          onChange={(event) => setInformation((prev) => ({ ...prev, insuranceId: event.target.value }))}>
                          <MenuItem value="">بدون بیمه تکمیلی</MenuItem>
                          {insurance.map((item) => <MenuItem key={item.idInsurance} value={item.idInsurance}>{item.InsuranceName}</MenuItem>)}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={4}>
                      <MDInput fullWidth type="text" inputProps={{ inputMode: "numeric" }} label="کد رهگیری بیمه (اختیاری)"
                        value={information.insuranceRefCode}
                        onChange={(event) => {
                          const code = event.target.value.replace(/[^0-9]/g, "");
                          setInformation((prev) => ({ ...prev, insuranceRefCode: code }));
                        }} />
                    </Grid>
                  </Grid>

                  <MDBox mb={2} sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <MDBox sx={{ borderRadius: "10px", bgcolor: "#e7f0ff", color: "#1976d2", width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 14 }}>۳</MDBox>
                    <MDTypography variant="h6" fontWeight="medium">انتخاب خدمت و زمان نوبت</MDTypography>
                  </MDBox>
                  <MDBox sx={{ p: { xs: 2, md: 3 }, borderRadius: "12px", backgroundColor: "#fafbfd", border: "1px solid #edf0f5" }}>
                    <Grid container spacing={2.5}>
                      <Grid item xs={12} sm={6} lg={3}>
                        <FormControl required fullWidth>
                          <Select value={service} onChange={handleChange} displayEmpty sx={{ height: "44.3px" }}>
                            <MenuItem value="">انتخاب درخواست</MenuItem>
                            {requestGroupData.map((item) => <MenuItem key={item.requestGroupId} value={item}>{item.nameGroup}</MenuItem>)}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={3}>
                        <FormControl required fullWidth>
                          <Select value={subService} onChange={handleChange1}
                            onClick={() => setOpenSubService(!openSubService)} displayEmpty open={openSubService}
                            disabled={!service} sx={{ height: "44.3px" }}>
                            <MenuItem value="">انتخاب خدمت</MenuItem>
                            {subRequestGroupData.map((item) => <MenuItem key={item.subRequestGroupId} value={item}>{item.subNameGroup}</MenuItem>)}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={3}>
                        <FormControl required fullWidth>
                          <Select value={clickedReservationDate} onChange={handleReservationDateChange}
                            onClick={() => setOpenReservationDate(!openReservationDate)} displayEmpty open={openReservationDate}
                            disabled={!subService} sx={{ height: "44.3px" }}>
                            <MenuItem value="">روز نوبت‌دهی</MenuItem>
                            {reservedDays.map((item, index) => <MenuItem key={index} value={item.reservationDate}>{`${String(item.reservationDate).slice(0, 4)}/${String(item.reservationDate).slice(4, 6)}/${String(item.reservationDate).slice(6)}`}</MenuItem>)}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={3}>
                        <FormControl required fullWidth>
                          <Select value={clickedReservationTime} onChange={handleReservationTimeChange}
                            onClick={() => setOpenReservationTime(!openReservationTime)} displayEmpty open={openReservationTime}
                            disabled={!clickedReservationDate} sx={{ height: "44.3px" }}>
                            <MenuItem value="">ساعت نوبت‌دهی</MenuItem>
                            {subTimesList.map((item) => <MenuItem disabled={isReservedSlot(item, reservedSubTimes)} key={item.key} value={item.key}>{item.time}</MenuItem>)}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    {(service || subService || clickedReservationDate || clickedReservationTime) && (
                      <MDBox mt={2} sx={{ p: 1.5, borderRadius: "8px", backgroundColor: "#edf5ff" }}>
                        <MDTypography variant="caption" color="text">
                          خلاصه نوبت: {service?.nameGroup || "درخواست انتخاب نشده"} {subService?.subNameGroup ? ` / ${subService.subNameGroup}` : ""}
                          {clickedReservationDate ? ` | ${String(clickedReservationDate).slice(0, 4)}/${String(clickedReservationDate).slice(4, 6)}/${String(clickedReservationDate).slice(6)}` : ""}
                          {selectedSlot ? ` | ساعت ${selectedSlot.time}` : ""}
                        </MDTypography>
                      </MDBox>
                    )}
                  </MDBox>
                  <MDBox mt={3} sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                    <MDButton onClick={submit} variant="gradient" color="info" disabled={loading}
                      sx={{ px: 5, minHeight: "44px", borderRadius: "10px" }}>
                      ثبت نوبت و ارسال لینک پرداخت
                    </MDButton>
                    <MDTypography variant="caption" color="text">پس از ثبت موفق، لینک پرداخت برای بیمار ارسال می‌شود.</MDTypography>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}
